module.exports = __webpack_public_path__ + "img/ulazna_posta.c5b6ac0b.svg";